import React from "react";
import Features from "./Features";
import Footer from "./Footer";
import Header from "./Header";
import IntroSegment from "./IntroSegment";
import { HomeContainer, HomeContent, LastHomeContent } from "./styles";
import Testimonials from "./Testimonials";
// import TrendCards from "./TrendCards";

function Home() {
  return (
    <HomeContainer>
      <Header />
      <HomeContent>
        <IntroSegment />
        {/* <TrendCards /> */}
      </HomeContent>
      <Features />
      <LastHomeContent>
        <Testimonials />
      </LastHomeContent>
      <Footer />
    </HomeContainer>
  );
}
export default Home;
